import { useEffect, useReducer } from 'react'
import { useQuery } from '../../tools/utilHooks'
import { useDispatch } from 'react-redux'
import { setModuleDataAction } from '../../modules/pagecache'
import { history, useTypedSelector } from '../../redux/store'
import { OrderType } from '../../tools/public'
import { GetLocalStorage } from '../../tools/util'

interface State {
  checkedOrderKey: OrderType
}
type ActionType = 'setCheckedOrderKey' | 'changedataAction'
interface Action {
  type: ActionType
  payload: any
}

const initialState: State = {
  checkedOrderKey: 'CUSTOMER',
}

const reducer = (state: State, action: Action): State => {
  let newstate = { ...state }
  switch (action.type) {
    case 'changedataAction':
      newstate = action.payload
      return newstate
    case 'setCheckedOrderKey':
      newstate.checkedOrderKey = action.payload
      return newstate

    default:
      throw new Error('not match actions')
  }
}

/**
 * 设置当前选中订单 tab的key值
 * @param key
 * @returns
 */
const setCheckedOrderKey = (val: string): Action => ({
  type: 'setCheckedOrderKey',
  payload: val,
})

const changedataAction = (param: State): Action => ({
  type: 'changedataAction',
  payload: param,
})

export default function useHook() {
  const [state, dispatch] = useReducer(reducer, initialState)
  const query = useQuery()
  const listState = query.get('listState') || ''
  const { pagekey } = useTypedSelector((state) => state.pageCache)
  const dispatchredux = useDispatch()
  useEffect(() => {
    const flag = getpagecache()
    if (flag) {
      const action = changedataAction(flag)
      dispatch(action)
    } else {
      if (GetLocalStorage('COOPERATETYPE') === '3') {
        if (listState && (listState === 'confirm' || 'stateReturn')) {
          dispatch(setCheckedOrderKey('CUSTOMER'))
        }
      } else if (GetLocalStorage('COOPERATETYPE') === '1') {
        dispatch(setCheckedOrderKey('SUPPLIER'))
      } else {
        dispatch(setCheckedOrderKey('CUSTOMER'))
      }
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    // 缓存存数据
    const pathName = history.location.pathname
    const action = setModuleDataAction({
      key: pathName,
      data: JSON.parse(JSON.stringify(state)),
    })
    dispatchredux(action)
    // eslint-disable-next-line
  }, [state])

  // 获取数据
  const getpagecache = () => {
    const pathName = history.location.pathname
    const data = pagekey.filter((item) => item.key === pathName)
    if (data.length === 1) {
      return data[0].data
    }
    return null
  }
  const { checkedOrderKey } = state
  const changeOrder = (key: string) => {
    dispatch(setCheckedOrderKey(key))
  }
  return {
    changeOrder,
    checkedOrderKey,
  }
}
import { useEffect, useReducer } from 'react'
import { useQuery } from '../../tools/utilHooks'
import { useDispatch } from 'react-redux'
import { setModuleDataAction } from '../../modules/pagecache'
import { history, useTypedSelector } from '../../redux/store'
import { OrderType } from '../../tools/public'
import { GetLocalStorage } from '../../tools/util'

interface State {
  checkedOrderKey: OrderType
}
type ActionType = 'setCheckedOrderKey' | 'changedataAction'
interface Action {
  type: ActionType
  payload: any
}

const initialState: State = {
  checkedOrderKey: 'CUSTOMER',
}

const reducer = (state: State, action: Action): State => {
  let newstate = { ...state }
  switch (action.type) {
    case 'changedataAction':
      newstate = action.payload
      return newstate
    case 'setCheckedOrderKey':
      newstate.checkedOrderKey = action.payload
      return newstate

    default:
      throw new Error('not match actions')
  }
}

/**
 * 设置当前选中订单 tab的key值
 * @param key
 * @returns
 */
const setCheckedOrderKey = (val: string): Action => ({
  type: 'setCheckedOrderKey',
  payload: val,
})

const changedataAction = (param: State): Action => ({
  type: 'changedataAction',
  payload: param,
})

export default function useHook() {
  const [state, dispatch] = useReducer(reducer, initialState)
  const query = useQuery()
  const listState = query.get('listState') || ''
  const { pagekey } = useTypedSelector((state) => state.pageCache)
  const dispatchredux = useDispatch()
  useEffect(() => {
    const flag = getpagecache()
    if (flag) {
      const action = changedataAction(flag)
      dispatch(action)
    } else {
      if (GetLocalStorage('COOPERATETYPE') === '3') {
        if (listState && (listState === 'confirm' || 'stateReturn')) {
          dispatch(setCheckedOrderKey('CUSTOMER'))
        }
      } else if (GetLocalStorage('COOPERATETYPE') === '1') {
        dispatch(setCheckedOrderKey('SUPPLIER'))
      } else {
        dispatch(setCheckedOrderKey('CUSTOMER'))
      }
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    // 缓存存数据
    const pathName = history.location.pathname
    const action = setModuleDataAction({
      key: pathName,
      data: JSON.parse(JSON.stringify(state)),
    })
    dispatchredux(action)
    // eslint-disable-next-line
  }, [state])

  // 获取数据
  const getpagecache = () => {
    const pathName = history.location.pathname
    const data = pagekey.filter((item) => item.key === pathName)
    if (data.length === 1) {
      return data[0].data
    }
    return null
  }
  const { checkedOrderKey } = state
  const changeOrder = (key: string) => {
    dispatch(setCheckedOrderKey(key))
  }
  return {
    changeOrder,
    checkedOrderKey,
  }
}
